import { useTranslation } from "react-i18next";
import { LicenceLeftMenu } from "../components/LicenceLeftMenu";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { headerHeight } from "../utils/constants";

const Certificate_of_Enlistment = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="" />
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <LicenceLeftMenu />
              </div>
            </div>
            <div className="col-lg-9"     style={{ minHeight: `calc(100vh - ${headerHeight+50}px)` }}>
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      
                      {t("Certificate of Enlistment (CE) : Home")}
                    </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h4 className="fontSizeClass">
                      {t(
                        "PROVISION OF THE KOLKATA MUNICIPAL CORPORATION ACT 1980:"
                      )}
                    </h4>
                    <p className="fontSizeClass">
                      {t(
                        "Licence Department Kolkata Municipal Corporation issues Certificate of Enlistment, by virtue of Chapter XIII containing Section 199(1) & 199(2) with provisos of KMC Act 1980 read with the Schedule of Rates/Fees/Charges of Licence Department as approved by Corporation in its Budget meeting for any financial year. By virtue of the said section, Licence Department acts as the nodal department collecting fees/charges of co-lateral sections also. For Details See The Guidlines order of UDMA Dept"
                      )}
                      .{" "}
                      <DownloadFileByFileStoreId
                        fileStoreId={"64a3420a-fa69-47c5-abce-33c193b36c27"}
                        label={"Click Here"}
                        classAdd={false}
                      />
                    </p>
                    <br />
                    <br />
                    <p className="fontSizeClass">
                        ●
                      <strong className="pl-1">
                        {t(
                          "For Trades liable to pay Water Supply Fees separately"
                        )}
                      </strong>
                      <br />
                      {t(
                        "(i) For ICI consumers, Receipt of current years Water Supply Fees along with receipt of current years Drainage & Sewerage Fees."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Certificate_of_Enlistment;
